import { API } from "@/services/api";
import { API_BASE_URL } from "@/config/env.config";
import { chatEndpoints } from "@/constant/endpoints";
import {
  ChatInboxResponse,
  ChatMessage,
  ChatMessagesPage,
  ChatSendPayload,
  ChatThreadsResponse,
} from "@/types/chat.types";

export const getChatThreadsService = async (dealId: string): Promise<ChatThreadsResponse> => {
  const response = await API.Get<ChatThreadsResponse>(chatEndpoints.threads(dealId));
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const getChatInboxService = async (): Promise<ChatInboxResponse> => {
  const response = await API.Get<ChatInboxResponse>(chatEndpoints.inbox);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const getChatMessagesService = async (
  dealId: string,
  threadId: string,
  before?: string,
): Promise<ChatMessagesPage> => {
  const response = await API.Get<ChatMessagesPage>(chatEndpoints.messages(dealId, threadId), {
    params: before ? { before } : undefined,
  });
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postChatMessageService = async (
  dealId: string,
  threadId: string,
  payload: ChatSendPayload,
): Promise<ChatMessage> => {
  const response = await API.Post<ChatSendPayload, ChatMessage>(chatEndpoints.messages(dealId, threadId), payload);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postChatReadService = async (dealId: string, threadId: string) => {
  return API.Post<undefined, { ok: boolean; last_read_at: string }>(chatEndpoints.read(dealId, threadId));
};

/**
 * The socket URL. One per signed-in tab, covering every deal. Derived from the same REACT_APP_BACKEND_URL the
 * REST client uses, so it follows the page onto https/wss automatically. An
 * empty backend URL means same-origin, which is resolved against the page.
 */
export const chatSocketUrl = (): string => {
  const url = new URL(`${API_BASE_URL}${chatEndpoints.socket}`, window.location.href);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
};
